export default "__VITE_ASSET__D7U$VKKg__"